import MaintenanceModal from '@/components/ErrorPages/MaintenanceModal';
import { getMaintenanceStatusApi } from '@/services/maintenance';
import React, { useEffect, useState } from 'react';
import { history, useLocation, useModel } from 'umi';

export const MAINTENANCE_EVENT = 'maintenance:detected';

const ALLOWED_PATHS = ['/login', '/contact-support', '/resetpassword'];

const SystemMaintenanceGate: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { initialState } = useModel('@@initialState');
  const location = useLocation();
  const [enabled, setEnabled] = useState<boolean>(
    Boolean((initialState as any)?.maintenanceEnabled),
  );

  useEffect(() => {
    const handler = () => setEnabled(true);
    window.addEventListener(MAINTENANCE_EVENT, handler);
    return () => window.removeEventListener(MAINTENANCE_EVENT, handler);
  }, []);

  useEffect(() => {
    if (!enabled) return;
    const interval = setInterval(async () => {
      try {
        const { enabled: still } = await getMaintenanceStatusApi();
        if (!still) setEnabled(false);
      } catch {
        // ignore
      }
    }, 15000);
    return () => clearInterval(interval);
  }, [enabled]);

  const isSuperuser = Boolean(initialState?.currentUser?.isSuperuser);
  const pathname = location?.pathname || history.location?.pathname || '';
  const isAllowedPath = ALLOWED_PATHS.some((p) => pathname.startsWith(p));
  const shouldBlock = enabled && !isSuperuser && !isAllowedPath;

  return (
    <>
      {children}
      <MaintenanceModal
        open={shouldBlock}
        closable={false}
        maskClosable={false}
        showButton={false}
        title="系統維護中"
        subTitle="系統正在進行維護升級，暫停服務。請稍候再試，造成不便敬請見諒。"
      />
    </>
  );
};

export default SystemMaintenanceGate;
